import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LocationsSection from './components/LocationsSection';
import CommunityImpactSection from './components/CommunityImpactSection';
import DropOffSection from './components/DropOffSection';
import HardDiskSection from './components/HardDiskSection';
import { testimonials, aggregateRating } from '@/mocks/testimonials';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com';

const HomeJsonLd = () => (
  <>
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      "url": `${SITE_URL}/`,
      "name": "Greenly Electronics Recycling",
      "description": "Los Angeles' certified electronics recycler — TV recycling, computer recycling, battery recycling, data destruction & hard drive shredding. CalRecycle CEWD-127531.",
      "publisher": { "@id": `${SITE_URL}/#business` },
      "potentialAction": {
        "@type": "SearchAction",
        "target": { "@type": "EntryPoint", "urlTemplate": `${SITE_URL}/?s={search_term_string}` },
        "query-input": "required name=search_term_string"
      }
    })}</script>
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      "url": `${SITE_URL}/`,
      "name": "Los Angeles Electronics Recycling | TV, Computer & Battery Recycling | Greenly",
      "description": "Certified electronics recycling in Los Angeles — free TV, computer & battery drop-off. CalRecycle CEWD-127531. Free business pickup. Call (213) 600-1000.",
      "isPartOf": { "@id": `${SITE_URL}/#website` },
      "about": { "@id": `${SITE_URL}/#business` },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` }]
      }
    })}</script>
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${SITE_URL}/#business`,
      "name": "Greenly Electronics Recycling",
      "url": `${SITE_URL}`,
      "telephone": "+12136001000",
      "email": "info@greenly.us",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2542 W. 3rd Street",
        "addressLocality": "Los Angeles",
        "addressRegion": "CA",
        "postalCode": "90057",
        "addressCountry": "US"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": aggregateRating.ratingValue,
        "reviewCount": aggregateRating.reviewCount,
        "bestRating": aggregateRating.bestRating,
        "worstRating": aggregateRating.worstRating
      },
    })}</script>
  </>
);

const HomePage = () => (
  <>
    <title>Greenly Electronics Recycling & Data Destruction</title>
    <meta name="description" content="Certified electronics recycling in Los Angeles — free TV, computer & battery drop-off. CalRecycle certified (CEWD-127531). Free business pickup. 2 LA locations. Call (213) 600-1000." />
    <meta name="robots" content="index, follow" />
    <meta name="last-modified" content="2026-05-11" />
    <link rel="canonical" href={`${SITE_URL}/`} />
    {/* Geo meta tags for local SEO — Los Angeles, CA */}
    <meta name="geo.region" content="US-CA" />
    <meta name="geo.placename" content="Los Angeles, California" />
    <meta name="geo.position" content="34.0522;-118.2437" />
    <meta name="ICBM" content="34.0522, -118.2437" />
    <HomeJsonLd />
    <Navbar />
    <main>
      <HeroSection />
      <LocationsSection />
      <CommunityImpactSection />
      <DropOffSection />
      <HardDiskSection />
    </main>
    <Footer />
  </>
);

export default HomePage;
